import { render } from "./TeamLeaguePanel.vue?vue&type=template&id=78477328&scoped=true"
import script from "./TeamLeaguePanel.vue?vue&type=script&lang=js"
export * from "./TeamLeaguePanel.vue?vue&type=script&lang=js"

import "./TeamLeaguePanel.vue?vue&type=style&index=0&id=78477328&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78477328"]])

export default __exports__